import React, { useState } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const CostLegend = () => {
	const [showTooltip, setShowTooltip] = useState(false);

	const costRanges = [
		{ range: '0', color: 'bg-gray-500', description: 'Custo 0' },
		{ range: '1-2', color: 'bg-green-500', description: 'Custo baixo (1-2)' },
		{ range: '3-4', color: 'bg-yellow-500', description: 'Custo médio (3-4)' },
		{ range: '5-6', color: 'bg-orange-500', description: 'Custo alto (5-6)' },
		{ range: '7+', color: 'bg-red-500', description: 'Custo muito alto (7+)' }
	];

	return (
		<div className="relative inline-block z-50">
			{/* Ícone de ajuda */}
			<button
				className="flex items-center space-x-2 text-slate-400 hover:text-slate-200 transition-colors"
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
				onClick={() => setShowTooltip(!showTooltip)}
			>
				<span className="text-sm font-medium"></span>
				<HelpOutlineIcon className="w-4 h-4" />
			</button>

			{/* Tooltip */}
			{showTooltip && (
				<div className="absolute z-50 bottom-full left-0 mb-8 w-64 bg-slate-800 border border-slate-600 rounded-lg shadow-xl p-4">
					<h4 className="text-slate-200 font-semibold mb-3 text-sm">Legenda das Cores dos Custos</h4>
					<div className="space-y-2">
						{costRanges.map((item, index) => (
							<div key={index} className="flex items-center space-x-3">
								<div className={`w-4 h-4 rounded-full ${item.color}`}></div>
								<span className="text-slate-300 text-xs">{item.description}</span>
							</div>
						))}
					</div>
					{/* Seta do tooltip */}
					<div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-slate-600"></div>
				</div>
			)}
		</div>
	);
};

export default CostLegend;